"use client"

import { useSession } from "next-auth/react"
import Link from "next/link"

export default function GuestBanner({ currentPath }: { currentPath: string }) {
  const { status } = useSession()

  if (status === "authenticated") return null

  return (
    <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800">
      <Link href={`/login?callbackUrl=${encodeURIComponent(currentPath)}`} className="font-semibold underline">
        Sign in
      </Link>{" "}
      or{" "}
      <Link href="/register" className="font-semibold underline">
        create a free account
      </Link>{" "}
      to apply for jobs.
    </div>
  )
}
